import { parseISO } from 'date-fns';
import { parseScheduledAt } from './dateUtilities';

export const WALL_CLOCK_TIME_ZONE = 'UTC';

const LOCAL_DATE_TIME_LENGTH = 'yyyy-MM-ddTHH:mm:ss'.length;

const browserWallClock = (time: Date) =>
  new Date(
    Date.UTC(
      time.getFullYear(),
      time.getMonth(),
      time.getDate(),
      time.getHours(),
      time.getMinutes(),
      time.getSeconds(),
    ),
  );

export const toPatientWallClock = (
  time: Date,
  timeInPatientTimeZone?: string | null,
) =>
  timeInPatientTimeZone
    ? parseISO(`${timeInPatientTimeZone.slice(0, LOCAL_DATE_TIME_LENGTH)}Z`)
    : browserWallClock(time);

export const appointmentWallClock = ({
  scheduledAt,
  scheduledAtInPatientTimeZone,
}: {
  scheduledAt: string;
  scheduledAtInPatientTimeZone?: string | null;
}) =>
  toPatientWallClock(
    parseScheduledAt(scheduledAt),
    scheduledAtInPatientTimeZone,
  );
